import React, { createContext, useContext, useState, useEffect } from 'react';
import { logEventoBD as logEventoService } from '../services/api/authService';
import { v4 as uuidv4 } from 'uuid';

export const calculateHoraFin = (ageHora, ageBloques) => {
  const [hours, minutes] = ageHora.split(':').map(Number);
  const endMinutes = minutes + ageBloques * 15;
  const endHours = hours + Math.floor(endMinutes / 60);
  return `${String(endHours).padStart(2, '0')}:${String(endMinutes % 60).padStart(2, '0')}`;
};

export const AppAgendaContext = createContext();

export const useAppAgendaContext = () => {
  return useContext(AppAgendaContext);
};

export const AppAgendaProvider = ({ children }) => {
  const [sessionId] = useState(uuidv4());
  const [flujoActivo, setFlujoActivo] = useState({
    origen: null,
    mp_origen: null,
    firma: null,
    firmaValida: false,
    inicioOK: false,
    pasosPermitidos: ['IndexPac'], // Parte siempre en IndexPac y Avanza Dinamico
  });
  const [odontologoRut, setOdontologoRut] = useState(null);
  const [paginaOrigen, setPaginaOrigen] = useState(null);
  const [odontRuts, setOdontRuts] = useState([]);

  const iniciarFlujoSeguro = ({ origen, mp_origen, firma }) => {
    const listaTiposValidos = ['default', 'landing_odontologo', 'flujo_rapido', 'whatsapp', 'web_mp'];

    console.log('🛡 VALIDANDO FIRMA...');
    console.log('📩 Firma recibida desde URL:', firma);
    const firmaEsperada = generarFirma(mp_origen);
    console.log('✅ Firma esperada generada localmente:', firmaEsperada);

    const firmaValida = firma === firmaEsperada;
    // const tipoValido = listaTiposValidos.includes(tipo_flujo);


    /*
    if (firmaValida && tipoValido) {
      setFlujoActivo({
        origen,
        tipo_flujo,
        mp_origen,
        firma,
        firmaValida: true,
        inicioOK: true,
        pasosPermitidos: [
          'IndexPac',
          'SeleccionaTipoHora',
          'SeleccionaFecHora',
          'ConfirmaFonoMail',
          'ConfirmaPaciente',
          'ConfirmaAgendamiento'
        ],
      });
      return true;
    } else {
      setFlujoActivo({
        origen,
        tipo_flujo,
        mp_origen,
        firma,
        firmaValida: false,
        inicioOK: false,
        pasosPermitidos: [],
      });
      return false;
    } */
  }; 

  const generarFirma = (mpOrigen, tipoFlujo) => {
    const secret = 'claveSecreta123';
    const base = `${mpOrigen}${tipoFlujo}${secret}`;
    return btoa(unescape(encodeURIComponent(base))).substring(0, 64);
  };

  const validarPaso = (paso) => {
    return flujoActivo.inicioOK && flujoActivo.pasosPermitidos.includes(paso);
  };
  
  const agregarPasoPermitido = (paso) => {
    setFlujoActivo(prev => {
      const yaExiste = prev.pasosPermitidos.includes(paso);
      if (!yaExiste) {
        const nuevosPasos = [...prev.pasosPermitidos, paso];
        const nuevoFlujo = { ...prev, pasosPermitidos: nuevosPasos };
        sessionStorage.setItem('flujoActivo', JSON.stringify(nuevoFlujo));
        return nuevoFlujo;
      }
      return prev;
    });
  };

  const logEventoBD = async ({ paso, evento, descripcion, campo, valor }) => {
    await logEventoService({
      paso,
      evento,
      descripcion,
      campo,
      valor,
      sessionId,
      contextData,
      utmData,
      flujoActivo
    });
  };

  useEffect(() => {
    const ua = navigator.userAgent;
    const isMobile = /Mobi|Android/i.test(ua);
    const isTablet = /Tablet|iPad/i.test(ua);
    const tipo = isMobile ? "Mobile" : isTablet ? "Tablet" : "Desktop";

    setContextData(prev => ({
      ...prev,
      userAgent: ua,
      dispositivoTipo: tipo,
      navegador: navigator.vendor || navigator.appName,
      sistemaOperativo: navigator.platform
    }));
  }, []);
  
  useEffect(() => {
    const storedTipo = sessionStorage.getItem('url_mpTipoTxt');
    const storedVal = sessionStorage.getItem('url_mpTipoVal');
    const storedClave = sessionStorage.getItem('claveFlujo');
    const storedFlujo = sessionStorage.getItem('flujoActivo');

    // Restaurar valores básicos del contexto
    if (storedTipo && storedVal) {
      setContextData(prev => ({
        ...prev,
        url_mpTipoTxt: storedTipo,
        url_mpTipoVal: storedVal,
        claveFlujo: storedClave || 'default'
      }));
    }

    // Restaurar estructura completa de flujo activo si existe
    if (storedFlujo) {
      try {
        const flujoParsed = JSON.parse(storedFlujo);
        if (flujoParsed?.inicioOK) {
          setFlujoActivo(flujoParsed);
        }
      } catch (error) {
        console.warn("❌ Error al restaurar flujoActivo desde sessionStorage:", error);
      }
    }
  }, []);  

  const [contextData, setContextData] = useState({
    sucursalId: null,
    sucursalNombre: '',
    sucursalDireccion: '',
    selectedDateTime: '',
    sillonNombre: '',
    doctorName: '',
    pacienteInfo: null,
    horId: null,
    ageFecha: '',
    ageHora: '',
    ageHoraFin: '',
    tiphoId: 7,
    ageNotas: '',
    sillID: 141,
    odontRut: null,
    pacRut: '', 
    pacDv: '',   
    pacNombre: '',
    pacCorreo: '',
    pacTelefono: '',
    pacienteEstado: null,
    odontologoRut: null,
    odontRuts: [],
    horariosDisponibles: [],
    paginaOrigen: null,
    paginaTipo: null,
    url_mpTipoTxt: null,
    url_mpTipoVal: null,
    claveFlujo: 'default'
  });

  // Datos UTM (capturados desde la URL y almacenados en sessionStorage)
  const [utmData, setUtmData] = useState({
    source: sessionStorage.getItem("utm_source") || null,
    medium: sessionStorage.getItem("utm_medium") || null,
    campaign: sessionStorage.getItem("utm_campaign") || null,
    term: sessionStorage.getItem("utm_term") || null,
    content: sessionStorage.getItem("utm_content") || null,
  });

  // Paso actual del usuario en el flujo
  const [pasoActual, setPasoActual] = useState("Inicio");

  // Último evento disparado a GTM (para debug visual)
  const [ultimoEventoGTM, setUltimoEventoGTM] = useState(null);
  const [eventosLog, setEventosLog] = useState([]);

const updatePacienteEstado = (estado) => {
  setContextData((prev) => ({
    ...prev,
    pacienteEstado: estado,
  }));
};

const setSucursalNombre = (nombre) => {
  setContextData((prev) => ({
      ...prev,
      sucursalNombre: nombre,
  }));
};

const updateContextData = (data) => {
  /* console.log('Actualizando contexto con datos:', data); */
  setContextData((prev) => {
    const ageHoraFin = calculateHoraFin(data.ageHora, data.ageBloques || 2);
    const newData = { ...prev, ...data, ageHoraFin };
    /* console.log('Estado del contexto actualizado:', newData); */
    return newData;
  });
};

const registrarEventoVisual = ({ paso, evento, descripcion }) => {
  setEventosLog(prev => {
    const nuevoEvento = {
      paso,
      evento,
      descripcion,
      timestamp: new Date().toLocaleTimeString()
    };

    const actualizados = [nuevoEvento, ...prev];
    return actualizados.slice(0, 5); // Solo mostrar los últimos 5
  });
};

const updatePacienteInfo = (pacienteData) => {
  /* console.log("updatePacienteInfo recibió los siguientes datos:", pacienteData); */

  // Evitar que valores vacíos sobrescriban los existentes
  setContextData(prev => ({
    ...prev,
    pacRut: pacienteData.pacRut || prev.pacRut,
    pacDv: pacienteData.pacDv || prev.pacDv,
    pacNombre: pacienteData.pacNombre || prev.pacNombre,
    pacCorreo: pacienteData.pacCorreo || prev.pacCorreo,
    pacTelefono: pacienteData.pacTelefono || prev.pacTelefono,
  }));

  /* console.log("Datos recibidos en updatePacienteInfo:", pacienteData); */
};


const updateSillonAndTipo = (sillID, tiphoId) => {
  setContextData((prev) => ({
    ...prev,
    sillID,
    tiphoId,
  }));
  /* console.log('Sillón y tipo actualizados:', { sillID, tiphoId }); */
};

const updateOdontRuts = (newRuts) => {
  setContextData(prev => ({
      ...prev,
      odontRuts: newRuts
  }));
};

const resetContextForNewFlow = () => {
  setContextData((prev) => ({
    ...prev,
    odontRuts: [],    // Limpia el array de odontólogos al cambiar de flujo
    odontologoRut: null, // Limpia el rut seleccionado
  }));
  setOdontRuts([]); // Asegurar que se limpian los RUTs
  /* console.log('Reseteando el contexto para nuevo flujo...'); */
};

const resetOdontRuts = () => {
  /* console.log('🧹 Limpiando odontRuts en contexto...'); */
  setContextData(prev => ({
      ...prev,
      odontRuts: []
  }));
};

const resetContextData = () => {
  /* console.log('🧹 Reseteando todo el contexto...'); */
  setContextData({
    sucursalId: null,
    sucursalNombre: '',
    sucursalDireccion: '',
    selectedDateTime: '',
    sillonNombre: '',
    doctorName: '',
    pacienteInfo: null,
    horId: null,
    ageFecha: '',
    ageHora: '',
    ageHoraFin: '',
    tiphoId: 7,
    ageNotas: '',
    sillID: 141,
    odontRut: null,
    pacRut: '', 
    pacDv: '',   
    pacNombre: '',
    pacCorreo: '',
    pacTelefono: '',
    pacienteEstado: null,
    odontologoRut: null,
    odontRuts: [],
    horariosDisponibles: [],
    paginaOrigen: null,
    paginaTipo: null  
  });
};

return (
    <AppAgendaContext.Provider
      value={{
        contextData,
        setContextData,
        updateContextData,
        updatePacienteInfo,
        updateSillonAndTipo,
        updatePacienteEstado,
        odontologoRut,
        setOdontologoRut,
        odontRuts,
        setOdontRuts,  
        paginaOrigen,
        setPaginaOrigen,
        resetContextForNewFlow,
        resetOdontRuts,
        updateOdontRuts,
        resetContextData,
        utmData,
        setUtmData,
        pasoActual,
        setPasoActual,
        ultimoEventoGTM,
        setUltimoEventoGTM,
        sessionId,
        logEventoBD,
        eventosLog,
        registrarEventoVisual,
        flujoActivo,
        setFlujoActivo,
        iniciarFlujoSeguro,
        validarPaso,
        agregarPasoPermitido
      }}
    >
    {children}
  </AppAgendaContext.Provider>
);
};